<template>
    <div class="headSssembly">
        <van-sticky>
            <div
                id="commonTop"
                :class="{'header':true,'headerDark':isDark}"
                :style="{'height':(parseFloat(topBar) + parseFloat(statusBar)) / 37.5+ 'rem','padding-top':parseFloat(statusBar) / 37.5  + 'rem'}"
            >
                <i v-if="true || isAppOpen" class="return"  @click="returnTop"></i>
                <span :class="{transparent: titleTransparent && transparent}">
                    {{title || titleTransparent}}
                </span>
                <template v-if="type == 'search'">
                    <span class="search">
                        <van-icon name="search" @click="goSearch" />
                        <van-icon v-if="showTitle" name="share" @click="Share"/>
                    </span>
                </template>
                <slot></slot>
            </div>
        </van-sticky>
    </div>
</template>

<script>
import { handleLocalStorage, isAndroid } from "@/utils/base"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "headSssembly",
    props: ['isDark', 'height', 'title', 'titleTransparent', 'type', 'logo', 'teamType'],
    data () {
        return {
            statusBar: handleLocalStorage('get', 'statusBar') || 40,
            topBar: handleLocalStorage('get', 'topBar') || 44,
            whiteArrows: require("../../assets/img/common/backLight.png"),
            blackArrows: require("../../assets/img/common/backBlack.png"),
            transparent: true
        }
    },
    mounted () {
        if (this.teamType !== 'team') {
            window.addEventListener("scroll", this.scrollEvent)
            this.scrollEvent()
        }
    },
    computed: {
        showTitle () {
            const src = this.$route.query.src
            if (src) {
                if (src.split('_')[2] === '106') {
                    return false
                } else {
                    return true
                }
            } else {
                return true
            }
        }
    },
    methods: {
        Share () {
            var desc = ""
            if (this.teamType === 'team') {
                desc = "查看球队最新动态、详细资料等"
            } else {
                desc = "查看球员最新动态、详细资料等"
            }
            var shareobj = {
                title: this.titleTransparent,
                desc: desc,
                link: window.location.href,
                imgUrl: this.logo
            }
            jsbridg.appShare(shareobj);
        },
        goSearch () {
            jsbridg.goGlobalSearch()
        },
        scrollEvent () {
            let domHeight;
            if (window.pageYOffset) {
                domHeight = window.pageYOffset;
            } else if (document.compatMode && document.compatMode !== 'BackCompat') {
                domHeight = document.documentElement.scrollTop;
            } else if (document.body) {
                domHeight = document.body.scrollTop;
            }
            const dom = document.getElementById('commonTop')
            let back = ''
            const num = (domHeight / ((this.height || 20) / 10) / 10)
            let url = this.isDark ? this.whiteArrows : this.whiteArrows
            let color = this.isDark ? '#fff' : "#333"
            if (this.isDark) {
                back = `rgba(0,0,0,${num})`
                if (num > 0.5) {
                    url = this.whiteArrows
                    color = "#fff"
                } else {
                    color = "#333"
                }
            } else {
                back = `rgba(255,255,255,${num})`
                if (num > 0.5) {
                    url = this.blackArrows
                    color = "#333"
                } else {
                    color = "#fff"
                }
            }
            if (num >= 1) {
                this.transparent = false
            } else {
                this.transparent = true
            }
            dom.style.background = back
            dom.style.color = color
            Array.from(dom.childNodes).find(item => item._prevClass === "return").style.backgroundImage = `url(${url})`
        },
        download () {
            this.$v.appCheckUpdate()
        },
        returnTop () {
            // this.$v.appPageQuit()
            if (isAndroid() === 1) {
                jsbridg.closeWebview()
            } else {
                jsbridg.goBack()
            }
        }
    }
}
</script>

<style lang="less" scoped>
.headSssembly{
    .header{
        position: relative;
        height: 45px;
        line-height: 45px;
        text-align: center;
        font-size:16px;
        font-weight:400;
        background: rgba(0, 0, 0, 0);
        color:#fff;
        overflow: hidden;
        .return{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/backLight.png");
            background-size: cover;
            z-index: 1;
        }
        .transparent{
            opacity: 0;
        }
        .download{
            position: absolute;
            right: 0;
            bottom: 0;
            width: 45px;
            height: 45px;
            background-image: url("../../assets/img/common/downloadHeader.png");
            background-size: cover;
            z-index: 1;
        }
        .search{
            font-size: 26px;
            position: absolute;
            right:14px;
            display: flex;
            justify-content: center;
            bottom: 8px;
            color: #fff;
            i{
                margin-left: 10px;
            }
        }
    }
    .headerDark{
        color: #333;
        .return{
            background-image: url("../../assets/img/common/backBlack.png");
        }

    }
}
</style>
